var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "externalAccountSetup" } }, [
    _c(
      "div",
      { staticClass: "vo-external-card" },
      [
        _c("div", { staticClass: "vo-body" }, [
          _c("div", { staticClass: "vo-title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("div", { staticClass: "vo-context" }, [
            _vm._v(
              "Please fill out the following form to complete your Vilio registration."
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section-title" }, [_vm._v("Profile")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("v-text-field", {
                ref: "firstNameInput",
                attrs: {
                  disabled: _vm.lockout,
                  "validate-on-blur":
                    _vm.$refs.firstNameInput && _vm.$refs.firstNameInput.valid,
                  label: "First Name",
                  type: "text",
                  rules: _vm.rules.name
                },
                model: {
                  value: _vm.user.firstName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.user,
                      "firstName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "user.firstName"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                ref: "lastNameInput",
                attrs: {
                  disabled: _vm.lockout,
                  "validate-on-blur":
                    _vm.$refs.lastNameInput && _vm.$refs.lastNameInput.valid,
                  label: "Last Name",
                  type: "text",
                  rules: _vm.rules.name
                },
                model: {
                  value: _vm.user.lastName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.user,
                      "lastName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "user.lastName"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                ref: "phoneInput",
                attrs: {
                  disabled: _vm.lockout,
                  "validate-on-blur":
                    _vm.$refs.phoneInput && _vm.$refs.phoneInput.valid,
                  label: "Phone #",
                  type: "text",
                  rules: _vm.rules.phone
                },
                model: {
                  value: _vm.user.phone,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.user,
                      "phone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "user.phone"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                ref: "pass1Input",
                attrs: {
                  disabled: _vm.lockout,
                  "validate-on-blur":
                    _vm.$refs.pass1Input && _vm.$refs.pass1Input.valid,
                  label: "Password",
                  type: "password",
                  rules: _vm.rules.pass1
                },
                model: {
                  value: _vm.user.password,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "password", $$v)
                  },
                  expression: "user.password"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                ref: "pass2Input",
                attrs: {
                  disabled: _vm.lockout,
                  "validate-on-blur":
                    _vm.$refs.pass2Input && _vm.$refs.pass2Input.valid,
                  label: "Confirm Password",
                  type: "password",
                  rules: _vm.rules.pass2
                },
                model: {
                  value: _vm.pass2,
                  callback: function($$v) {
                    _vm.pass2 = $$v
                  },
                  expression: "pass2"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "section-title" }, [
            _vm._v("\n        Notifications\n        "),
            _c("div", { staticClass: "icon-wrapper" }, [
              _c(
                "div",
                { staticClass: "icon" },
                [_c("v-icon", [_vm._v("mdi-email")])],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "icon" },
                [_c("v-icon", [_vm._v("mdi-cellphone")])],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section" },
            [
              _vm.invite
                ? _vm._l(_vm.notificationSettings, function(item, key) {
                    return !item.managerOnly ||
                      (item.managerOnly &&
                        !_vm.invite.role.hasOwnProperty("unit"))
                      ? _c("div", { key: key, staticClass: "noti-container" }, [
                          _c("div", { staticClass: "noti-title" }, [
                            _vm._v(_vm._s(item.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "noti-checkbox-email" },
                            [
                              "email" in item
                                ? [
                                    _c("v-checkbox", {
                                      attrs: {
                                        disabled: _vm.lockout,
                                        "hide-details": "",
                                        color: "primary"
                                      },
                                      model: {
                                        value: item.email,
                                        callback: function($$v) {
                                          _vm.$set(item, "email", $$v)
                                        },
                                        expression: "item.email"
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "noti-checkbox-push" },
                            [
                              "push" in item
                                ? [
                                    _c("v-checkbox", {
                                      staticClass: "checkbox",
                                      attrs: {
                                        disabled: _vm.lockout,
                                        "hide-details": "",
                                        color: "primary"
                                      },
                                      model: {
                                        value: item.push,
                                        callback: function($$v) {
                                          _vm.$set(item, "push", $$v)
                                        },
                                        expression: "item.push"
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clear" })
                        ])
                      : _vm._e()
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "section-title" }, [
            _vm._v("Terms of Use & Privacy Policy")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "tos" }, [
              _c("div", { staticClass: "tos-title" }, [
                _vm._v("By checking the box, you agree to our "),
                _c("a", { attrs: { href: _vm.policyUrl, target: "_blank" } }, [
                  _vm._v("Terms of Service & Privacy Policy.")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "checkbox" },
                [
                  _c("v-checkbox", {
                    attrs: {
                      disabled: _vm.lockout,
                      "hide-details": "",
                      color: "primary"
                    },
                    model: {
                      value: _vm.tos,
                      callback: function($$v) {
                        _vm.tos = $$v
                      },
                      expression: "tos"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            directives: [{ name: "ripple", rawName: "v-ripple" }],
            staticClass: "vo-card-button",
            attrs: { block: "", flat: "", loading: _vm.lockout },
            on: { click: _vm.createAccount }
          },
          [_vm._v("COMPLETE")]
        ),
        _vm._v(" "),
        _c("vo-external-header", { attrs: { title: _vm.title } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8722cb2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8722cb2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalAccountSetup.vue
// module id = 645
// module chunks = 4